import { render, staticRenderFns } from "./table-show-range-head.vue?vue&type=template&id=f181a1ca"
import script from "./table-show-range-head.vue?vue&type=script&lang=js"
export * from "./table-show-range-head.vue?vue&type=script&lang=js"
import style0 from "./table-show-range-head.vue?vue&type=style&index=0&id=f181a1ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports